export default {
  common: {
    menu: "menu",
    keywordSearch: "Type Keyword to Search",
    actions: "Actions",
    add: "Add",
    edit: "Edit",
    view: "View",
    tag: "Tag",
    collapseMenu: "Collapse Menu",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    deleteConfirmMsg: "Are you sure you want to delete?",
    no: "No",
    yes: "Yes",
    noDataAvailable: "No Data Available",
    reason: "Reason",
    createdBy: "Created By",
    modifiedBy: "Modified By",
    saveChanges: "Save Changes",
    close: "Close",
    pleaseEnter: "Please Enter...",
    globalSmartSearch: "Global Search...",
    loadingText: "We are loading the data for you. Please wait.",
    collapse: "Collapse",
    expand: "Expand",
    search: 'Search',
    paracetamol: 'paracetamol',
    disable: 'Disable',
    saveAndNext: 'Save & Next',
    inactive: 'Inactive',
    user: 'User',
    downloadPDF: 'Download as PDF',
    typeofAssociation: "Type of Association",
    recordName: "Record Name",
    tip: {
      addSuccess: "Add successfully.",
      addFailed: "Add failed.",
      updateSuccess: "Update successfully.",
      updateFailed: "Update failed.",
      revertSuccess: "Revert successfully.",
      revertFailed: "Revert failed.",
      deleteSuccess: "Delete successfully.",
      deleteFailed: "Delete failed.",
      deletion: "Please enter a reason for deletion.",
      limit_2000: "The input exceeds the maximum limit of 2,000 characters.",
      selectOneItem: "Please select one item.",
      selectTarget: "Please select target first.",
    },
  },
  validation: {
    isRequired: "is required"
  },
  menu: {
    dashboards: "Dashboards",
    products: "Products",
    rtqs: "RTQs",
    components: "Components",
    component_contents: "Component Contents",
    settings: "Settings",
    document_types: "Document Types",
    document_records: "Document Records",
    published_documents: "Published Documents",
    pinned: "Pinned",
    recent: "Recent",
    searchModule: "Search Module",
    aiAssistant: "AI Assistant",
    modules: 'Modules',
    devices: "Devices",
  },
  device: {
    devicePhase: "Device Phase",
    deviceCategory: "Device Category",
    deviceType: "Device Type",
    deviceName: "Device Name",
    status: "Status",
    devices: "Devices",
    addDevice: "Add Device",
    showDisabled: 'Show Disabled',
    showActive: 'Show Active',
    showInactive: 'Show Inactive',
    updateProductSuccessTip: 'Device updated successfully.',
    createProductSuccessTip: 'Device created successfully.',
    deleteProductSuccessTip: 'Device deleted successfully.',
    addDevice: "Add Device",
    editDevice: "Edit Device",
    viewDevice: "View Device",
    productsDes: "Device Information",
    reasonForInactive: "Reason for Inactive",
    deviceInformation: 'Device Information',
    documents: "Documents"
  },
  product: {
    document: {
      chooseFile: 'Choose File',
      switchRadioButton: 'Moving between the radio buttons will lead to loss of the data',
      deleteDocumentSuccessTip: 'Document deleted successfully.',
      updateDocumentSuccessTip: 'Document updated successfully.',
      addDocumentSuccessTip: 'Document added successfully.',
      editDocument: 'Edit Document',
      addDocument: 'Add Document',
      documentURL: 'Document URL',
      uploadFromLocal: 'Upload from Local',
      documentNumber: 'Document Number',
      documentName: 'Document Name',
      url: 'URL',
      confirmDeleteDocument: 'Are you sure you want to delete this Document?',
      allowedFileTypes: "<b>Note</b> : Allowed File Types \"<b>.doc, docx, .pdf, jpeg, .xlsx</b>\", Max size: <b>5MB</b>",
      waringAllowedFileTypes: 'Please upload files smaller than 5MB'
    },
    file: {
      uploadFileSuccessTip: 'File uploaded successfully.'
    },
  }
}